import Route from 'cio/routes/base';
import { action } from '@ember/object';
import Transition from '@ember/routing/-private/transition';
import ListController from './controller';

const CHILD_ROUTES = {
  newsletters: 'broadcasts.list.newsletters.index',
  api_triggered_broadcasts: 'broadcasts.list.api-triggered.index',
};

export default class ListRoute extends Route {
  // If a particular child route (tab) was active earlier, we want to
  // transition to it again. This is done so that when you visit a particular
  // broadcast's setup or overview and want to go back up, you are taken to
  // the right tab.
  redirect(_: any, transition: Transition) {
    // In case the transition is specifically to a child route, we can skip any redirects.
    if (Object.values(CHILD_ROUTES).includes(transition.to.name)) {
      return;
    }

    let controller = this.controllerFor('broadcasts.list') as ListController;
    this.router.transitionTo(controller.lastActiveChildRouteName ?? CHILD_ROUTES.newsletters);
  }

  resetController(controller: ListController, isExisting: boolean, transition: Transition) {
    super.resetController(controller, isExisting, transition);

    this.setProperties<any>({
      page: 1,
      search: '',
    });
  }

  // Normally with an explicit index route that contains a redirect, it takes
  // you to the intended beginning of that section. When we have a tabbed page,
  // like Broadcasts, where each tab is a route, however, clicking the main nav
  // will redirect to the initial tab again, rather than staying put. It's a
  // consequence of our routing pattern being used with tabs.
  //
  // Additionally, the `redirect` method/hook will not fire when navigating UP
  // in the stack, so we need to use the `willTransition` event.
  @action
  willTransition(transition: Transition) {
    if (
      transition.to.name === 'broadcasts.list.index' &&
      transition.from &&
      Object.values(CHILD_ROUTES).includes(transition.from.name)
    ) {
      transition.abort();
    }
  }
}
